import { call, put } from 'redux-saga/effects';
import ERRORS from 'constants/errors';
import STEPS from 'constants/steps';
import { setError, startLoading, stopLoading, setStep } from 'reduxConfig/auth.creators';

import { verifyLoginGetSession } from './verifyLoginGetSession';

export function* authVerifyLogin({
  email,
  idToken,
  twoFactorCode,
  useRecoveryCode,
  forceRefreshIdToken
} = {}) {
  yield put(setError(null));
  yield put(startLoading());
  try {
    yield call(verifyLoginGetSession, {
      email,
      idToken,
      twoFactorCode,
      useRecoveryCode,
      forceRefreshIdToken
    });
  } catch (error) {
    if (error === 'no_session_found') {
      try {
        yield call(verifyLoginGetSession, {
          email,
          idToken,
          twoFactorCode,
          useRecoveryCode,
          forceRefreshIdToken,
          isRetry: true
        });
      } catch (e) {
        console.error(`authVerifyLogin (no_session_found) ${e.name}: ${e.message}`, { error: e });
        yield put(setError(ERRORS.login));
        yield put(stopLoading());
      }
    } else {
      if (error.response) {
        const errorCode = error.originalError.error;
        if (errorCode === 'missing_code_field') {
          yield put(setStep(STEPS.verifyCode));
        } else if (errorCode === 'invalid_code_field') yield put(setError(ERRORS.twoFactor));
        else if (errorCode === 'account_locked') yield put(setError(ERRORS.accountLocked));
        else {
          console.error('authVerifyLogin', error);
          yield put(setError(ERRORS.login));
        }
      } else {
        console.error(error, `authVerifyLogin (no response) ${error?.name}: ${error?.message}`);
        yield put(setError(ERRORS.login));
      }
      yield put(stopLoading());
    }
  }
}
